import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=612a1d08"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports